import { Link, useParams, useSearchParams } from "react-router-dom";
import { Meta } from "../components/Meta";
import { ProductDetails } from "../components/ProductDetails";
import { productPath, routes } from "../config/routes";
import { products } from "../data/catalogue";

export function ProductPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const legacyId = searchParams.get("id");
  const querySlug = searchParams.get("slug");
  const product = products.find(
    (item) =>
      item.slug === slug ||
      item.slug === querySlug ||
      item.id === legacyId ||
      item.slug === legacyId
  );

  if (!product) {
    return (
      <main id="main" className="content-page">
        <Meta
          title="Collection coming soon | Beautify Ourselves"
          description="The Beautify Ourselves beauty collection is coming soon."
          path={slug ? productPath(slug) : routes.productHtml}
          noIndex
        />
        <div className="empty-state">
          <p className="eyebrow">The collection</p>
          <h1>The collection is taking shape.</h1>
          <p>Explore our beauty categories while we prepare the first collection.</p>
          <Link className="button" to={routes.shop}>
            Explore categories
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main id="main">
      <Meta
        title={`${product.name} | Beautify Ourselves`}
        description={product.description}
        path={productPath(product.slug)}
      />
      <ProductDetails product={product} />
    </main>
  );
}
